module.exports = __webpack_public_path__ + "static/media/bukaCheck2.175cac5d.png";